export default "__VITE_ASSET__qUughKLC__"